import { createFilterSet, NumericFilterOperator, FilterInstance } from '../../../../../../generic-search-common/src'
import { useState, useEffect } from 'react'
import { FilterProps } from '../../utils'
import { preventChangeOnScroll } from '../../../../../../../../services/form-utils'
import { InputWidth, TextInput } from '@msaf/core-react'

const FILTER_OPERATOR = Object.freeze({
  LOWER: '>=',
  UPPER: '<=',
})

export function FilterNumericRange(filterProps: FilterProps) {
  const [lower, setLower] = useState('')
  const [upper, setUpper] = useState('')

  const { filterKey, value, setValue } = filterProps

  useEffect(() => {
    if (value && typeof value !== 'string') {
      const queryFilters = value.filterSet.filters as FilterInstance[]
      queryFilters.forEach(({ filterOperator, filterValue }) => {
        if (filterOperator === FILTER_OPERATOR.LOWER) {
          setLower(filterValue ?? '')
        } else if (filterOperator === FILTER_OPERATOR.UPPER) {
          setUpper(filterValue ?? '')
        }
      })
    }
  }, [value])

  /**
   * Returns the filter set with the updated filter value.
   * Excludes filters with no value selected.
   * @param filterValue Selected date formatted as a string
   * @param filterOperator Use to identify which date value (upper or lower) to update
   * @returns Filter set with non empty filters
   */
  const getAppliedFilterSet = (filterValue: string, filterOperator: NumericFilterOperator) => {
    if (typeof value !== 'string') {
      const queryFilters = value.filterSet.filters as FilterInstance[]
      if (filterOperator === FILTER_OPERATOR.LOWER) {
        queryFilters.splice(0, 1, { filterKey, filterValue, filterOperator })
      } else if (filterOperator === FILTER_OPERATOR.UPPER) {
        queryFilters.splice(1, 1, { filterKey, filterValue, filterOperator })
      }
      return createFilterSet(queryFilters, 'AND')
    } else {
      return createFilterSet(
        [
          {
            filterKey,
            filterValue,
            filterOperator,
          },
        ],
        'AND',
      )
    }
  }

  const handleChange = (bound: 'lower' | 'upper', value: string) => {
    if (bound === 'lower') {
      setValue(getAppliedFilterSet(value, FILTER_OPERATOR.LOWER as NumericFilterOperator))
    } else if (bound === 'upper') {
      setValue(getAppliedFilterSet(value, FILTER_OPERATOR.UPPER as NumericFilterOperator))
    }
  }

  return (
    <div className='generic-search-filter__input-numeric-range-container'>
      <div className='generic-search-filter__input-numeric-range'>
        <TextInput
          id='lower'
          type='number'
          onWheel={preventChangeOnScroll}
          placeholder='From'
          fieldSize={InputWidth.large}
          setValue={(value) => handleChange('lower', value)}
          value={lower}
        />
        <div className='generic-search-filter__input-numeric-range-spacer'>–</div>
        <TextInput
          id='upper'
          type='number'
          onWheel={preventChangeOnScroll}
          placeholder='To'
          fieldSize={InputWidth.large}
          setValue={(value) => handleChange('upper', value)}
          value={upper}
        />
      </div>
    </div>
  )
}
